var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2Fuse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.39 16H18v-6h-4v6h-2a4 4 0 00-4 3.88v35.37A4 4 0 0012 59h2v6h4v-6h2.39a4 4 0 003.56-3.46H24V19.61A4 4 0 0020.39 16zM20 20v35.13h-8V19.88h8V20zm48-.39A4 4 0 0064.39 16H62v-6h-4v6h-2a4 4 0 00-4 3.88v35.37A4 4 0 0056 59h2v6h4v-6h2.39a4 4 0 003.56-3.46H68V19.61zM64 20v35.13h-8V19.88h8V20zm-21.61-4H40v-6h-4v6h-2a4 4 0 00-4 3.88v35.37A4 4 0 0034 59h2v6h4v-6h2.39a4 4 0 003.56-3.46H46V19.61A4 4 0 0042.39 16zM42 20v35.13h-8V19.88h8V20z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Fuse.199a63af.svg";
export { SvgA2Fuse as ReactComponent };